import React from "react";
import Page from "../components/Page";

const Privacy = () => <Page title="Privacy">this is the Privacy</Page>;

export default Privacy;
